import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'category', 'image' ]

  connect() {
    this.toggleClass = 'invisible'
  }

  findImage(e) {
    return this.imageTargets.find((image) => image.getAttribute('id') == `img-${e.currentTarget.dataset.img}`)
  }

  showImage(e) {
    let image = this.findImage(e)
    if (image) image.classList.remove(this.toggleClass)
  }

  hideImage(e) {
    let image = this.findImage(e)
    if (image) image.classList.add(this.toggleClass)
  }
}
